module.exports = __webpack_public_path__ + "img/金额.5563e168.png";